import React, { Component } from "react";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import CreateIcon from "@material-ui/icons/Create";
import { connect } from "react-redux";

import { addSettings } from "../../../actions";
import {
  listAvailableServices,
  getServiceDetails,
  fetchIntegrationDetails,
  getClientKycDetail,
  voyceLogin,
  save_login_voyce,
} from "./../../../config/client_api_calls";

import $ from "jquery";

import DataTableExtended from "../../../components/Tables/DataTableExtended";
//import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import { TableLoader } from "../../../components/ContentLoaders/newLoaders/TableLoader";
import { tableLoaderListing } from "../../../components/ContentLoaders/table_loader_listing";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import {
  THEME_TEXT_COLOR,
  THEME_COLOR,
  ADMIN_URL,
  KYC_URL,
  APP_URL,
} from "./../../../config/config";
import MutextField from "@material-ui/core/TextField";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";

import Tooltip from "@material-ui/core/Tooltip";
import dateFormat from "dateformat";

import TextField from "../../../components/InputFields/TextField";

const auth = new HelperClass();

const newHeight = window.screen.height;

class Services extends Component {
  constructor() {
    super();

    this.state = {
      tableData: [],
      serviceData: [],
      tableDataBundle: [],
      completeData: [],
      defaultServices: [],
      errorMessage: "",
      serviceId: "",
      successMessage: "",
      waitMessage: "",
      tableLoader: true,
      tableLoaderListing: true,
      tableLoaderBundle: true,
      nrc_rate_type: "Flat",
      defaultNrc: "",
      defaultMrc: "",
      new_nrc: "",
      new_mrc: "",
      rate_type: "",
      rate: "",
      defaultRate: "",
      defaultSmsIn: "",
      defaultSmsOut: "",
      agent_mrc_comission: 0,
      agent_nrc_comission: 0.0,
      agent_rate_comission: 0,
      sms_in_comission: 0,
      sms_out_comission: 0,
      update_nrc: "",
      update_mrc: "",
      update_rate: "",
      product_id: "",
      product_desc: "",
      mrc_rate_type: "Flat",
      service_title: "",
      service_type_edit: "",
      default_mrc: "",
      default_nrc: "",
      default_rate: "",
      default_sms_in: "",
      default_sms_out: "",
      sms_in: "",
      sms_out: "",
      sms_in_percentage: "",
      sms_out_percentage: "",
      mrc_percentage: "",
      rate_percentage: "",
      select_service: "",
      bundleServiceDetails: [],
      bundleDetails: [],
      columnBundleServices: [],
      currentlink: "",
      currentPdfLink: "",
      sso_link: "",
      successMessageSso: "",
      errorMessageSso: "",
      forgotLink: "",
      login_email: "",
      errorLoginEmail: "",
      login_password: "",
      errorLoginPassword: "",
      disabled: false,
      voyceadmins_api_url: "",
      downloadLoader: false,

      unsigned_agreement_title: "",
      unsigned_agreement_accountno: "",
      service_id: "",
      form_accountno: "",
      form_link: "",
      coming_soon: "",

      selectedServiceIds: [],
      next_sequence_no: "",

      selectedServiceTitle: "",
      columnServices: [
        {
          name: "Select",
          options: {
            customHeadRender: () => {
              // Make sure the disable condition matches exactly what's in the body
              const allSelectable = this.state.tableData
                .filter((row) => {
                  const formAccountNo = row[10];
                  const formLink = row[11];
                  // A row is selectable if it's NOT disabled
                  return !(
                    formAccountNo &&
                    formAccountNo !== "" &&
                    formLink &&
                    formLink !== ""
                  );
                })
                .map((row) => row[1]); // extract serviceId using same index as body

              const allChecked =
                allSelectable.length > 0 &&
                allSelectable.every((id) =>
                  this.state.selectedServiceIds.includes(id),
                );

              return (
                <th
                  key="select-all-services-head"
                  style={{
                    textAlign: "center !important",
                    verticalAlign: "middle !important",
                    borderBottom: "1px solid #e5e9f2",
                    padding: "0 !important",
                    minWidth: "70px",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minHeight: "48px",
                      width: "100%",
                    }}
                  >
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="select-all-services"
                        onChange={(e) => this.handleSelectAll(e, allSelectable)}
                        checked={allChecked}
                        disabled={allSelectable.length === 0}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="select-all-services"
                        style={{
                          marginBottom: "0",
                          cursor:
                            allSelectable.length === 0
                              ? "not-allowed"
                              : "pointer",
                          opacity: allSelectable.length === 0 ? 0.5 : 1,
                        }}
                      ></label>
                    </div>
                  </div>
                </th>
              );
            },

            customBodyRenderLite: (dataIndex) => {
              const row = this.state.tableData[dataIndex];
              const serviceId = row[1];
              const formAccountNo = row[10];
              const formLink = row[11];
              const isDisabled =
                formAccountNo &&
                formAccountNo !== "" &&
                formLink &&
                formLink !== "";

              const checkboxId = `service-checkbox-${serviceId}`;

              return (
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "100%",
                    minHeight: "48px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minHeight: "48px",
                      width: "100%",
                    }}
                  >
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id={checkboxId}
                        checked={
                          !isDisabled &&
                          this.state.selectedServiceIds.includes(serviceId)
                        }
                        onChange={(e) =>
                          !isDisabled && this.handleCheckboxChange(e, serviceId)
                        }
                        disabled={isDisabled}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor={checkboxId}
                        style={{
                          marginBottom: "0",
                          cursor: isDisabled ? "not-allowed" : "pointer",
                          opacity: isDisabled ? 0.5 : 1,
                        }}
                      ></label>
                    </div>
                  </div>
                </div>
              );
            },
          },
        },
        {
          name: "SKU",
          options: {
            customBodyRender: (value, tableMeta) => {
              const serviceId = tableMeta.rowData[1];
              const sku = tableMeta.rowData[2];
              const title = tableMeta.rowData[3];
              return (
                <button
                  type="button"
                  onClick={() => this.showDetails(serviceId, tableMeta)}
                  aria-label={`Open details for ${title} (SKU: ${sku})`}
                  style={{
                    background: "none",
                    border: "none",
                    color: "#6576ff",
                    cursor: "pointer",
                    textDecoration: "underline",
                    padding: 0,
                    font: "inherit",
                  }}
                  onKeyPress={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      this.showDetails(serviceId, tableMeta);
                    }
                  }}
                >
                  {sku}
                </button>
              );
            },
          },
        },
        {
          name: "Title",
          options: {
            customBodyRender: (value, tableMeta) => {
              const serviceId = tableMeta.rowData[1];
              const sku = tableMeta.rowData[2];
              const title = tableMeta.rowData[3];
              return (
                <button
                  type="button"
                  onClick={() => this.showDetails(serviceId, tableMeta)}
                  aria-label={`Open details for ${title} (SKU: ${sku})`}
                  style={{
                    background: "none",
                    border: "none",
                    color: "#6576ff",
                    cursor: "pointer",
                    textDecoration: "underline",
                    padding: 0,
                    font: "inherit",
                    textAlign: "left",
                  }}
                  onKeyPress={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      this.showDetails(serviceId, tableMeta);
                    }
                  }}
                >
                  {title}
                </button>
              );
            },
          },
        },
        {
          name: "Date Added",
          options: {
            display: "false",
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_date_initial(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "Price",
          options: {
            customBodyRender: (value, tableMeta) => {
              const fullRow = this.state.tableData[tableMeta.rowIndex];
              const price = fullRow ? fullRow[15] : undefined;
              const rateDeck = fullRow ? fullRow[21] : undefined;

              // Check if service has rate deck
              if (rateDeck && rateDeck !== "") {
                return (
                  <a
                    onClick={() => this.downloadDeck(rateDeck)}
                    style={{ cursor: "pointer" }}
                  >
                    <span className="badge badge-outline-info">
                      <em className="icon ni ni-download"></em> Rate Deck
                    </span>
                  </a>
                );
              }

              // Show price for services without rate deck
              if (price === undefined || price === null || price === "") {
                return this.formatAsCurrencys(0);
              }
              const numericPrice = parseFloat(price);
              if (isNaN(numericPrice)) {
                return this.formatAsCurrencys(0);
              }
              return this.formatAsCurrencys(numericPrice);
            },
          },
        },
        {
          name: "Marketing",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.defaultMarketing(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "Order",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.defaultText(value, tableMeta)}</div>;
            },
          },
        },
      ],
      columnBundleServices: [
        {
          name: "bundle_title",
          label: "Title",
          options: {
            filter: true,
          },
        },
        {
          name: "per_month_rate",
          label: "Per Month Rate (Charge Monthly)",
          options: {
            filter: true,
          },
        },
        {
          name: "per_year_rate",
          label: "Per Month Rate (Charge Yearly)",
          options: {
            filter: true,
          },
        },
        {
          name: "date_added",
          label: "Date Added",
          options: {
            customBodyRender: (value) => {
              return <div>{this.format_date(value)}</div>;
            },
          },
        },
        {
          name: "id",
          label: "Actions",
          options: {
            customBodyRender: (value) => {
              return (
                <div>
                  <div
                    className="nk-tb-col nk-tb-col-tools"
                    style={{ padding: "0px" }}
                  >
                    <ul className="nk-tb-actions gx-1">
                      <li>
                        <div className="drodown">
                          <a
                            style={{ cursor: "pointer" }}
                            title="Other Actions"
                            className="dropdown-toggle btn btn-icon  btn-outline-light"
                            data-toggle="dropdown"
                          >
                            <em className="icon ni ni-more-h"></em>
                          </a>
                          <div className="dropdown-menu dropdown-menu-right">
                            <ul className="link-list-opt no-bdr">
                              <li>
                                <Tooltip
                                  title="Package Details"
                                  placement="top"
                                >
                                  <a
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      this.showBundleDetails(value)
                                    }
                                    disabled={
                                      this.props.is_msa_signed === "No" ||
                                        this.props.defaultSettings === "missing"
                                        ? true
                                        : false
                                    }
                                  >
                                    <em className="icon ni ni-list"></em>
                                    <span>Package Details</span>
                                  </a>
                                </Tooltip>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              );
            },
          },
        },
      ],
    };
  }
  viewBtns = () => {
    if (
      this.props.is_msa_signed === "No" ||
      this.props.defaultSettings === "missing"
    ) {
      return <VisibilityOffIcon />;
    } else {
      return <VisibilityIcon style={{ cursor: "pointer" }} />;
    }
  };

  serviceSigning = async (value, tableMeta) => {
    //console.log("tableMeta.rowData: ", tableMeta.rowData[6]);
  };

  async componentDidMount() {
    await this.setServiceList();
    window.addEventListener("message", this.handlePostMessage);
  }

  componentWillUnmount() {
    // Remove event listener when component unmounts
    window.removeEventListener("message", this.handleMessage);
  }

  setServiceList = async () => {
    const servicesResponce = await listAvailableServices(
      auth.getClientAccount(),
      auth.getClientToken(),
    );
    // console.log("listAvailableServices: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        tableData: [],
        next_sequence_no: "",
        tableLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        tableData: servicesResponce.data.data,
        next_sequence_no: servicesResponce.data.next_sequence_no || "",
        tableLoader: false,
      });
    } else {
      this.setState({
        tableData: [],
        next_sequence_no: "",
        tableLoader: false,
      });
      //window.location.replace("/error");
    }
  };

  connect_integration = async (value, tableMeta) => {
    let integration = tableMeta.rowData[8];
    let kyc_rerquired = tableMeta.rowData[6];

    if (kyc_rerquired === "Yes") {
      const servicesResponce = await getClientKycDetail(
        auth.getClientAccount(),
        auth.getClientToken(),
      );
      // console.log("KYC Details: ", servicesResponce.data);
      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.clientLogout();
      } else if (servicesResponce.data.status === 406) {
        //window.location.replace("/error");
      } else if (servicesResponce.data.status === 404) {
        //window.location.replace("/error");
      } else if (servicesResponce.data.status === 200) {
        if (
          servicesResponce.data.steps_allowed ===
          servicesResponce.data.steps_completed
        ) {
          this.fetchIntegration(integration);
        } else {
          window.location.href =
            KYC_URL + "client/register/" + servicesResponce.data.kyc_key;
        }
      }
    } else {
      this.fetchIntegration(integration);
    }
  };

  fetchIntegration = async (integration) => {
    const servicesResponce = await fetchIntegrationDetails(
      auth.getClientAccount(),
      auth.getClientToken(),
      integration,
    );
    // console.log("fetchIntegrationDetails: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        clientData: servicesResponce.data.data[0],
      });
      let json = JSON.stringify({
        email: this.state.clientData.email, //"sufyain@tcpaas.com", // this.state.clientData.email,
        comp_name: this.state.clientData.comp_name,
        name: this.state.clientData.name,
        phone: this.state.clientData.phone,
        address: this.state.clientData.address,
        city: this.state.clientData.city,
        state: this.state.clientData.state,
        zip: this.state.clientData.zip,
        country: this.state.clientData.country,
      });
      const userEencodedString = btoa(json);
      if (integration === "voycetel") {
        var w = 600;
        var h = 650;
        var left = window.screen.width / 2 - w / 2;
        var top = window.screen.height / 2 - h / 2;
        var LoginUrl =
          servicesResponce.data.integration.other_settings.login_url;
        let childWindow = window.open(
          LoginUrl + "?user_hash=" + userEencodedString,
          "_blank",
          "width=600,height=650,top=" + top + ",left=" + left,
        );
        setTimeout(function () {
          if (childWindow.opener) {
            // console.log("Child window has a parent window.");
            // console.log(" window.", childWindow);
          } else {
            // console.log("Child window does not have a parent window.");
          }
        }, 6000);
      } else if (integration === "voyceadmins") {
        if (
          this.state.clientData.voyceadmins_access_token === null ||
          this.state.clientData.voyceadmins_access_token === ""
        ) {
          if (servicesResponce.data.user_exist === false) {
            var LoginUrl =
              servicesResponce.data.integration.other_settings.login_url +
              "?ref_url=" +
              btoa(APP_URL) +
              "&ref_key=1234567890&hash=" +
              userEencodedString;
            this.setState({
              sso_link: LoginUrl,
              successMessageSso: "",
              errorMessageSso: "",
            });
            window.$("#modalSsoRegister").modal("show");
          } else {
            /// open login modal for SSO  VoyceAdmins
            this.setState({
              login_email: this.state.clientData.email,
              forgotLink:
                servicesResponce.data.integration.api_url +
                "account/forgotpassword",
              errorLoginEmail: "",
              login_password: "",
              errorLoginPassword: "",
              voyceadmins_api_url: servicesResponce.data.integration.api_url,
              successMessageSso: "",
              errorMessageSso: "",
            });
            window.$("#modalSsoLogin").modal("show");
          }
        } else {
          let url =
            servicesResponce.data.integration.api_url +
            "account/access_auth?url=dashboard&access_token=" +
            this.state.clientData.voyceadmins_access_token;
          // console.log("url = ", url);
          window.open(url);
        }
      }
    } else {
      //window.location.replace("/error");
    }
  };

  format_date = (value, tableMeta) => {
    let date = value;
    return dateFormat(date, "mm-dd-yyyy");
  };
  format_date_initial = (value, tableMeta) => {
    let date = tableMeta.rowData[4];
    return dateFormat(date, "mm-dd-yyyy");
  };

  defaultMarketing = (value, tableMeta) => {
    //console.log("tableMeta.rowData: ", tableMeta.rowData[9]);
    let is_default = value.split("###");
    let marketing_content = is_default[0];
    let marketing_link = is_default[1];
    if (marketing_link && marketing_link != "") {
      if (marketing_content === "link") {
        return (
          <a
            style={{ cursor: "pointer" }}
            onClick={() => this.openLink(marketing_link)}
          >
            <span className="badge badge-outline-primary">
              <em className="icon ni ni-signin"></em> Product Info
            </span>
          </a>
        );
      } else if (marketing_content === "pdf") {
        // Check if it's an image based on file extension
        const fileUrl = marketing_link;
        const fileExtension = fileUrl.split(".").pop().toLowerCase();
        const isImage = ["jpg", "jpeg", "png"].includes(fileExtension);

        if (isImage) {
          return (
            <img
              src={fileUrl}
              alt="Marketing"
              style={{
                width: "50px",
                height: "50px",
                objectFit: "cover",
                cursor: "pointer",
              }}
              onClick={() => this.showDetails(value, tableMeta)}
            />
          );
        } else {
          return (
            <a
              style={{ cursor: "pointer" }}
              onClick={() => this.openPDFlink(marketing_link)}
            >
              <span className="badge badge-outline-primary">
                <em className="icon ni ni-download"></em> View PDF
              </span>
            </a>
          );
        }
      } else {
        return "";
      }
    } else {
      return "---";
    }
  };

  defaultText = (value, tableMeta) => {
    // Get the full row data from tableData using rowIndex
    const fullRow = this.state.tableData[tableMeta.rowIndex];

    let service_id = fullRow ? fullRow[1] : tableMeta.rowData[1];
    let form_accountno = fullRow ? fullRow[10] : undefined;
    let form_link = fullRow ? fullRow[11] : undefined;
    let coming_soon = fullRow ? fullRow[12] : undefined;

    if (coming_soon === 1) {
      return (
        <span className="badge badge-outline-warning">
          <em className="icon ni ni-clock"></em> Coming Soon
        </span>
      );
    }

    return (
      <>
        {form_accountno &&
          form_accountno !== "" &&
          form_link &&
          form_link !== "" ? (
          <a
            href={`${APP_URL}${auth.getResellerRegToken()}/client/client_form_submit/${form_accountno}/${form_link}/${service_id}?order=add`}
          >
            <span className="badge badge-outline-primary">
              <em className="icon ni ni-cart"></em> Form Order
            </span>
          </a>
        ) : (
          <a
            href={`${APP_URL}${auth.getResellerRegToken()}/client/EditSalesOrder/${this.getOrderNo()}/${service_id}?order=add`}
          >
            <span className="badge badge-outline-primary">
              <em className="icon ni ni-cart"></em> Order Now
            </span>
          </a>
        )}
      </>
    );
    /*let { kyc_completed } = this.state;
    let is_default = tableMeta.rowData[4];
    let service_id = tableMeta.rowData[0];
    let service_name = tableMeta.rowData[1];
    return "---";*/
    /*return (
      <>
        {is_default === "Yes" ? (
          <a
            onClick={() =>
              this.signService(service_id, is_default, service_name)
            }
            style={{ cursor: "pointer" }}
          >
            <span className="badge badge-outline-success">
              <em className="icon ni ni-cart"></em> Order Now
            </span>
          </a>
        ) : (
          <a
            onClick={() =>
              this.signService(service_id, is_default, service_name)
            }
            style={{ cursor: "pointer" }}
          >
            <span className="badge badge-outline-success">
              <em className="icon ni ni-cart"></em> Order Now
            </span>
          </a>
        )}
      </>
    );*/
  };

  showDetails = async (value, tableMeta) => {
    // Get the full row data from tableData using rowIndex
    const fullRow = this.state.tableData[tableMeta.rowIndex];

    let service_id = fullRow ? fullRow[1] : tableMeta.rowData[1];
    let service_title = fullRow ? fullRow[3] : tableMeta.rowData[3];
    let form_accountno = fullRow ? fullRow[10] : undefined;
    let form_link = fullRow ? fullRow[11] : undefined;
    let coming_soon = fullRow ? fullRow[12] : undefined;
    this.setState({
      errorMessage: "",
      successMessage: "",
      unsigned_agreement_title: "",
      unsigned_agreement_accountno: "",
      service_id: service_id,
      selectedServiceTitle: service_title || "Product Details",
      form_accountno: form_accountno,
      form_link: form_link,
      coming_soon: coming_soon,
    });
    const servicesResponce = await getServiceDetails(
      auth.getClientAccount(),
      auth.getClientToken(),
      service_id,
    );
    // console.log("getAgentService: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessage: "There is some error while getting the service data.",
        successMessage: "",
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        serviceData: servicesResponce.data.data,
        unsigned_agreement_title:
          servicesResponce.data.assigned_agreement_title,
        tableLoader: false,
        tableLoaderListing: false,
        errorMessage: "",
      });
    } else {
      this.setState({
        errorMessage: "There is some error while getting the service data.",
        successMessage: "",
      });
      //window.location.replace("/error");
    }
    window.$("#modalFormDetailDash").modal("show");
  };

  getOrderNo = () => {
    return this.state.next_sequence_no;
  };

  modalHide = () => {
    window.$("#modalFormDetailDash").modal("hide");
  };

  modalHideMarketingLink = () => {
    this.setState({
      currentlink: "",
    });
    window.$("#modalMarketingLink").modal("hide");
  };

  modalHideSsoRegister = () => {
    this.setState({
      sso_link: "",
      successMessageSso: "",
      errorMessageSso: "",
    });
    window.$("#modalSsoRegister").modal("hide");
  };

  modalHideSsoLogin = () => {
    this.setState({
      sso_link: "",
      successMessageSso: "",
      errorMessageSso: "",
    });
    window.$("#modalSsoLogin").modal("hide");
  };

  modalHideMarketingPDF = () => {
    this.setState({
      currentPdfLink: "",
    });
    window.$("#modalMarketingPDFLink").modal("hide");
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  openLink = (link) => {
    this.setState({
      currentlink: link,
    });
    window.$("#modalMarketingLink").modal("show");
  };

  openPDFlink = (link) => {
    this.setState({
      currentPdfLink: link,
    });
    window.$("#modalMarketingPDFLink").modal("show");
  };

  downloadDeck = async (d_f_name) => {
    if (d_f_name !== "") {
      this.setState({ downloadLoader: true });
      var url = ADMIN_URL + "files_data/logos/" + d_f_name;
      const parts = url.split("/");
      let file_name = d_f_name;

      fetch(url)
        .then((x) => x.blob())
        .then((b) => {
          // console.log("B INSTANCE", b instanceof Blob);
          const url = window.URL.createObjectURL(b);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = file_name;
          a.click();
          window.URL.revokeObjectURL(url);
          this.setState({ downloadLoader: false });
        })
        .catch((error) => {
          this.setState({ downloadLoader: false });
          console.error("Fetch error:", error);
        });
    }
  };

  handlePostMessage = async (event) => {
    const message = event.data;
    // console.log("Received message:", message);
    if (event.data.registration == "registration_success") {
      let asscessToken = event.data.token;
      let redirect_url = event.data.reg_complete_url;

      let apiResponce = await save_login_voyce(
        auth.getClientAccount(),
        auth.getClientToken(),
        asscessToken,
      );
      // console.log("save_login_voyce response -> ", apiResponce.data);

      if (
        apiResponce.data.status === 403 ||
        apiResponce.data.errors === "authentication missing" ||
        apiResponce.data.errors === "jwt expired"
      ) {
        auth.clientLogout();
      } else if (
        apiResponce.data.status === 200 &&
        apiResponce.data.message === "success"
      ) {
        // this.setState({
        //   successMessageSso: "Please wait, redirecting to the dashboard",
        // });
        this.setState({
          successMessageSso: "User Registred Successsfully",
        });
        setTimeout(() => {
          this.setState({
            successMessageSso: "",
          });
          this.modalHideSsoRegister();
          // let url =
          //   redirect_url + "?url=dashboard&access_token=" + asscessToken;
          //   console.log("url = ",url);
          window.open(redirect_url);
        }, 1000);
      } else {
        this.setState({
          errorMessageSso: apiResponce.data.message,
          disabled: false,
        });
        setTimeout(() => {
          this.setState({
            errorMessageSso: "",
            disabled: false,
          });
        }, 3000);
      }
    }
  };

  handleChange = (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
  };

  formLogin = async () => {
    let { login_email, login_password } = this.state;

    let is_validated = true;
    if (login_email === "") {
      this.setState({
        errorLoginEmail: "error",
        errorLoginPassword: "",
        errorMessageSso: "Email is required.",
      });
      is_validated = false;
    } else if (login_password === "") {
      this.setState({
        errorLoginEmail: "",
        errorLoginPassword: "error",
        errorMessageSso: "Password is required.",
      });
      is_validated = false;
    }

    if (is_validated) {
      this.setState({
        errorLoginEmail: "",
        errorLoginPassword: "",
        errorMessageSso: "",
        disabled: true,
      });

      let apiResponce = await voyceLogin(
        auth.getClientAccount(),
        auth.getClientToken(),
        login_email,
        login_password,
        this.state.voyceadmins_api_url,
      );
      // console.log("login response -> ", apiResponce.data);

      if (
        apiResponce.data.status === 403 ||
        apiResponce.data.errors === "authentication missing" ||
        apiResponce.data.errors === "jwt expired"
      ) {
        auth.clientLogout();
      } else if (
        apiResponce.data.status === 200 &&
        apiResponce.data.message === "success"
      ) {
        this.setState({
          errorLoginEmail: "",
          errorLoginPassword: "",
          successMessageSso: "Please wait, redirecting to the dashboard",
          disabled: true,
          login_email: "",
          forgotLink: "",
          login_password: "",
          errorLoginPassword: "",
          voyceadmins_api_url: "",
        });
        setTimeout(() => {
          this.setState({
            errorLoginEmail: "",
            errorLoginPassword: "",
            errorMessageSso: "",
            disabled: false,
          });
          this.modalHideSsoLogin();
          window.open(
            apiResponce.data.data.url.access_auth +
            "?url=dashboard&access_token=" +
            apiResponce.data.data.access_token,
          );
        }, 3000);
      } else {
        this.setState({
          errorLoginEmail: "",
          errorLoginPassword: "",
          errorMessageSso: apiResponce.data.message,
          disabled: false,
        });
        setTimeout(() => {
          this.setState({
            errorLoginEmail: "",
            errorLoginPassword: "",
            errorMessageSso: "",
            disabled: false,
          });
        }, 3000);
      }
    } else {
      setTimeout(() => {
        this.setState({
          errorLoginEmail: "",
          errorLoginPassword: "",
          errorMessageSso: "",
          disabled: false,
        });
      }, 3000);
    }
  };

  formatAsCurrencys = (amount) => {
    // console.log("amount: ", typeof amount);
    //amount = this.formatRate(amount);
    let decimal_point = 2;
    if (
      this.props.quotationSettings[0]?.decimal_point &&
      this.props.quotationSettings[0]?.decimal_point !== ""
    ) {
      decimal_point = this.props.quotationSettings[0]?.decimal_point;
    }
    if (typeof amount === "string") {
      amount = parseFloat(amount);
    }

    return amount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: decimal_point,
      maximumFractionDigits: decimal_point,
    });
  };

  formatRate = (rate) => {
    let decimal_point = 2;
    if (
      this.props.quotationSettings[0]?.decimal_point &&
      this.props.quotationSettings[0]?.decimal_point !== ""
    ) {
      decimal_point = this.props.quotationSettings[0]?.decimal_point;
    }
    // Ensure rate is a number
    if (typeof rate !== "number") {
      rate = parseFloat(rate);
    }

    // Handle case where rate is NaN (invalid input)
    if (isNaN(rate)) {
      //return "Invalid rate";
      return (0).toFixed(decimal_point);
    }

    // Handle case where rate is zero
    if (rate === 0) {
      return (0).toFixed(decimal_point);
    }

    // Round the rate to the specified decimal points
    const formattedRate = rate.toFixed(decimal_point);

    return formattedRate;
  };

  handleCheckboxChange = (e, serviceId) => {
    this.setState((prevState) => {
      const selected = new Set(prevState.selectedServiceIds);
      if (e.target.checked) {
        selected.add(serviceId);
      } else {
        selected.delete(serviceId);
      }
      return { selectedServiceIds: Array.from(selected) };
    });
  };

  handleSelectAll = (e, allServiceIds) => {
    this.setState((prevState) => {
      if (e.target.checked) {
        const merged = new Set([
          ...prevState.selectedServiceIds,
          ...allServiceIds,
        ]);
        return { selectedServiceIds: Array.from(merged) };
      } else {
        const filtered = prevState.selectedServiceIds.filter(
          (id) => !allServiceIds.includes(id),
        );
        return { selectedServiceIds: filtered };
      }
    });
  };

  render() {
    //$(".nk-block .MUIDataTable-paper-2").css("padding", "10px");
    // console.log(
    //   "Service Props: ",
    //   this.props.quotationSettings[0]?.decimal_point
    // );
    return (
      <div
        className={
          this.props.from === "dashboard"
            ? "nk-content newcontent_padding"
            : "nk-content"
        }
        id="Services_Block"
      >
        <div
          className={
            this.props.from === "dashboard"
              ? "container-fluid newcontainerfluid_padding"
              : "container-fluid"
          }
        >
          {this.props.defaultSettings === "missing" &&
            this.props.from !== "dashboard" ? (
            <SettingsError />
          ) : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" &&
            this.props.from !== "dashboard" ? (
            <MsaWarning />
          ) : null}

          {/* MSA WARNING END */}

          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* PAGE TITLE START */}
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      <PageTitle
                        name="Products & Services"
                        icon="icon ni ni-package"
                      />
                    </h3>
                  </div>
                  <div className="nk-block-head-content" id="HeadContent">
                    <div className="toggle-wrap nk-block-tools-toggle">
                      {/* <a
                        href="#"
                        className="btn btn-icon btn-trigger toggle-expand mr-n1"
                        data-target="pageMenu"
                      >
                        <em className="icon ni ni-more-v"></em>
                      </a> */}
                      <div
                        className="toggle-expand-content"
                        data-content="pageMenu"
                      >
                        <ul className="nk-block-tools g-3">
                          <li className="nk-block-tools-opt">
                            {this.state.selectedServiceIds.length > 0 && (
                              <a
                                href={`${APP_URL}${auth.getResellerRegToken()}/client/EditSalesOrder/${this.getOrderNo()}/${this.state.selectedServiceIds.join(
                                  ",",
                                )}`}
                                className="btn btn-primary ml-3"
                              >
                                <em
                                  className="icon ni ni-cart"
                                  style={{ marginBottom: "3px" }}
                                ></em>
                                <span>Order Now</span> (
                                {this.state.selectedServiceIds.length})
                              </a>
                            )}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  {/* <div className="nk-block-head-content" id="HeadContent">
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#"
                        className="btn btn-icon btn-trigger toggle-expand mr-n1"
                        data-target="pageMenu"
                      >
                        <em className="icon ni ni-more-v"></em>
                      </a>
                      <div
                        className="toggle-expand-content"
                        data-content="pageMenu"
                      >
                        <ul className="nk-block-tools g-3">
                          <li className="nk-block-tools-opt">
                            {this.props.defaultSettings !== "missing" ? (
                              <a
                                href={"/" + auth.getResellerIdentifier() +  "/client/services/Addservice"}
                                style={{
                                  color: "#fff",
                                }}
                                className="btn btn-primary"
                              >
                                <em className="icon ni ni-plus-round"></em>
                                <span>Add New Service</span>
                              </a>
                            ) : null}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
              {/* PAGE TITLE END */}
              <div className="nk-block">
                <div className="row g-gs">
                  {/* Table 5th Col Start */}
                  <div className="col-xxl-12">
                    <div className="nk-block nk-block-lg">
                      <div className="card card-bordered">
                        <div className="card-inner">
                          <div className="tab-content">
                            <div className="tab-pane active" id="tabItem5">
                              {/* START DATATABLE */}
                              {this.state.tableLoader === true ? (
                                TableLoader()
                              ) : (
                                <DataTableExtended
                                  columns={this.state.columnServices}
                                  tableData={this.state.tableData}
                                  title="All Packages"
                                />
                              )}

                              {/* END TABLE */}
                            </div>
                            <div className="tab-pane" id="tabItem6">
                              {this.state.tableLoaderBundle === true ? (
                                TableLoader()
                              ) : (
                                <>
                                  {this.state.tableDataBundle &&
                                    this.state.tableDataBundle.length > 0 ? (
                                    <DataTableExtended
                                      columns={this.state.columnBundleServices}
                                      tableData={this.state.tableDataBundle}
                                      title="All Packages"
                                    />
                                  ) : null}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Table 5th Col End */}
                  {/*  DETAILS MODAL*/}
                  <div
                    className="modal fade zoom"
                    tabIndex="-1"
                    id="modalFormDetail"
                  >
                    <div
                      className="modal-dialog modal-xl modal-dialog-top"
                      role="document"
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <div
                            className="modal-title"
                            style={{ textAlign: "center", fontSize: "20px" }}
                          >
                            <strong>
                              <em className="icon ni ni-list-round"></em>{" "}
                              Product Details
                            </strong>
                          </div>
                          <a
                            href="#"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                        </div>

                        <div className="modal-body">
                          <br />
                          {/* NRC DIVS START */}

                          {this.state.serviceData ? (
                            <>
                              <div>
                                {this.state.serviceData.map((services, idx) => (
                                  <div
                                    className="card card-bordered"
                                    key={`servi${idx}`}
                                  >
                                    <div className="card-inner-group">
                                      {this.state.unsigned_agreement_title &&
                                        this.state.unsigned_agreement_title !==
                                        "" ? (
                                        <div className="example-alert">
                                          <div className="alert alert-warning alert-icon">
                                            <em className="icon ni ni-alert-circle"></em>{" "}
                                            Your agreement{" "}
                                            <strong>
                                              {
                                                this.state
                                                  .unsigned_agreement_title
                                              }
                                            </strong>{" "}
                                            is missing.
                                          </div>
                                        </div>
                                      ) : null}
                                      {services[6] === "did" ||
                                        services[6] === "tfn" ||
                                        services[6] === "teams" ? (
                                        <div className="card-inner">
                                          <div className="sp-plan-head">
                                            <h6 className="title">
                                              {services[1]}
                                              <span className="badge badge-dim badge-primary badge-pill">
                                                {services[6] === "did"
                                                  ? "DID Origination"
                                                  : ""}
                                                {services[6] === "tfn"
                                                  ? "Toll Free Origination"
                                                  : ""}
                                                {services[6] === "term"
                                                  ? "Voice Termination"
                                                  : ""}
                                                {services[6] === "teams"
                                                  ? "Microsoft Teams UCAAS"
                                                  : ""}
                                                {services[6] === "ivr"
                                                  ? "Voyce Admins"
                                                  : ""}
                                                {services[6] === "tfn_term"
                                                  ? "Toll Free Termination"
                                                  : ""}
                                                {services[6] === "az_term"
                                                  ? "International A-Z Termination"
                                                  : ""}
                                                {services[6] === "live_agent"
                                                  ? "Live Agent"
                                                  : ""}
                                                {services[6] === "generic"
                                                  ? "Other Services"
                                                  : ""}
                                                {services[6] === "sms"
                                                  ? "SMS Inbound / Outbound"
                                                  : ""}
                                              </span>
                                            </h6>
                                          </div>

                                          <div className="sp-plan-desc sp-plan-desc-mb">
                                            <ul className="row gx-1">
                                              <li className="col-sm-4">
                                                <p>
                                                  <span className="text-soft">
                                                    NRC
                                                    <Tooltip
                                                      title="Non-Recurring Charge – A one-time fee that is deducted on service setup."
                                                      placement="top"
                                                    >
                                                      <em
                                                        className="icon ni ni-info"
                                                        style={{
                                                          color: "#6576ff",
                                                        }}
                                                      ></em>
                                                    </Tooltip>
                                                  </span>{" "}
                                                  ${services[4]}
                                                </p>
                                              </li>
                                              <li className="col-sm-4">
                                                <p>
                                                  <span className="text-soft">
                                                    MRC{" "}
                                                    <Tooltip
                                                      title="Monthly Recurring Charge - what you pay each month for the service."
                                                      placement="top"
                                                    >
                                                      <em
                                                        className="icon ni ni-info"
                                                        style={{
                                                          color: "#6576ff",
                                                        }}
                                                      ></em>
                                                    </Tooltip>
                                                  </span>{" "}
                                                  ${services[5]}
                                                </p>
                                              </li>
                                              {services[23] !== "ratedeck" ? (
                                                <li className="col-sm-4">
                                                  <p>
                                                    <span className="text-soft">
                                                      Rate Per Minute{" "}
                                                      <Tooltip
                                                        title="Rate assigned per minute."
                                                        placement="top"
                                                      >
                                                        <em
                                                          className="icon ni ni-info"
                                                          style={{
                                                            color: "#6576ff",
                                                          }}
                                                        ></em>
                                                      </Tooltip>
                                                    </span>{" "}
                                                    ${services[7]}
                                                  </p>
                                                </li>
                                              ) : null}
                                            </ul>
                                          </div>
                                        </div>
                                      ) : null}
                                      {services[6] === "term" ||
                                        services[6] === "ivr" ||
                                        services[6] === "live_agent" ||
                                        services[6] === "tfn_term" ||
                                        services[6] === "az_term" ||
                                        services[6] === "generic" ? (
                                        <div className="card-inner">
                                          <div className="sp-plan-head">
                                            <h6 className="title">
                                              {services[1]}{" "}
                                              <span className="badge badge-dim badge-primary badge-pill">
                                                {services[6] === "did"
                                                  ? "DID Origination"
                                                  : ""}
                                                {services[6] === "tfn"
                                                  ? "Toll Free Origination"
                                                  : ""}
                                                {services[6] === "term"
                                                  ? "DID Termination"
                                                  : ""}
                                                {services[6] === "teams"
                                                  ? "Microsoft Teams UCAAS"
                                                  : ""}
                                                {services[6] === "ivr"
                                                  ? "Voyce Admins"
                                                  : ""}
                                                {services[6] === "tfn_term"
                                                  ? "Toll Free Termination"
                                                  : ""}
                                                {services[6] === "az_term"
                                                  ? "International A-Z Termination"
                                                  : ""}
                                                {services[6] === "live_agent"
                                                  ? "Live Agent"
                                                  : ""}
                                                {services[6] === "sms"
                                                  ? "SMS Inbound / Outbound"
                                                  : ""}
                                                {services[6] === "generic"
                                                  ? "General Products & Services"
                                                  : ""}
                                                {services[23] === "ratedeck"
                                                  ? " ( Rate Deck )"
                                                  : ""}
                                              </span>
                                            </h6>
                                          </div>

                                          <div className="sp-plan-desc sp-plan-desc-mb">
                                            <ul className="row gx-1">
                                              {services[23] === "ratedeck" ? (
                                                <>
                                                  {/*<li className="col-sm-4">
                                                    <p>
                                                      <span className="text-soft">
                                                        Agent Commission
                                                      </span>{" "}
                                                      {services[14]}%
                                                    </p>
                                                  </li>
                                                  <li className="col-sm-4">
                                                    <p>
                                                      <span className="text-soft">
                                                        Effective Date
                                                      </span>{" "}
                                                      {services[24]}
                                                    </p>
                                                  </li>
                                                  <li className="col-sm-4">
                                                    <p>
                                                      <span className="text-soft">
                                                        Download Rate Deck
                                                      </span>{" "}
                                                      <a
                                                        onClick={() =>
                                                          this.downloadCsv(
                                                            services[25]
                                                          )
                                                        }
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        className="btn btn-outline-primary"
                                                      >
                                                        <em className="icon ni ni-download"></em>{" "}
                                                        Download Rate Deck
                                                      </a>
                                                    </p>
                                                  </li>*/}
                                                </>
                                              ) : (
                                                <li className="col-sm-4">
                                                  <p>
                                                    <span className="text-soft">
                                                      {services[6] === "generic"
                                                        ? "Price"
                                                        : "Rate Per Minute"}{" "}
                                                      <Tooltip
                                                        title={
                                                          services[6] ===
                                                            "generic"
                                                            ? "Rate assigned"
                                                            : "Rate assigned per minute"
                                                        }
                                                        placement="top"
                                                      >
                                                        <em
                                                          className="icon ni ni-info"
                                                          style={{
                                                            color: "#6576ff",
                                                          }}
                                                        ></em>
                                                      </Tooltip>
                                                    </span>{" "}
                                                    $
                                                    {this.formatRate(
                                                      services[7],
                                                    )}
                                                  </p>
                                                </li>
                                              )}
                                            </ul>
                                          </div>
                                          {services[6] === "generic" ? (
                                            <>
                                              <div
                                                className="sp-plan-head"
                                                style={{
                                                  marginTop: "15px",
                                                  borderTop:
                                                    "1px solid #f6f6f6",
                                                  paddingTop: "15px",
                                                }}
                                              >
                                                <h6 className="title">
                                                  Other Service Rates
                                                </h6>
                                              </div>
                                              <div className="sp-plan-desc sp-plan-desc-mb">
                                                <table className="table">
                                                  <thead className="thead-light">
                                                    <tr>
                                                      <th scope="col">Title</th>
                                                      <th scope="col">
                                                        Charge Type
                                                      </th>
                                                      <th scope="col">Cycle</th>
                                                      <th scope="col">Price</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {services[34].map(
                                                      (miscrate, idx) => (
                                                        <tr key={`mis${idx}`}>
                                                          <td>
                                                            {
                                                              miscrate.generic_title
                                                            }
                                                          </td>
                                                          <td>
                                                            {miscrate.included_in_price !==
                                                              0 ? (
                                                              <>
                                                                {miscrate.pay_type ===
                                                                  "recurring"
                                                                  ? "Recurring"
                                                                  : ""}

                                                                {miscrate.pay_type ===
                                                                  "one_time"
                                                                  ? "One Time"
                                                                  : ""}
                                                              </>
                                                            ) : null}
                                                          </td>
                                                          <td>
                                                            {miscrate.included_in_price !==
                                                              0 ? (
                                                              <>
                                                                {miscrate.pay_type ===
                                                                  "recurring" ? (
                                                                  <>
                                                                    {miscrate.generic_type ===
                                                                      "per_minute"
                                                                      ? "Per Minute"
                                                                      : ""}
                                                                    {miscrate.generic_type ===
                                                                      "per_hour"
                                                                      ? "Per Hour"
                                                                      : ""}
                                                                    {miscrate.generic_type ===
                                                                      "per_second"
                                                                      ? "Per Second"
                                                                      : ""}
                                                                    {miscrate.generic_type ===
                                                                      "per_day"
                                                                      ? "Per Day"
                                                                      : ""}
                                                                    {miscrate.generic_type ===
                                                                      "per_month"
                                                                      ? "Per Month"
                                                                      : ""}
                                                                    {miscrate.generic_type ===
                                                                      "per_year"
                                                                      ? "Per Year"
                                                                      : ""}
                                                                  </>
                                                                ) : null}
                                                              </>
                                                            ) : null}
                                                          </td>
                                                          <td>
                                                            {miscrate.included_in_price !==
                                                              0 ? (
                                                              <>
                                                                {miscrate.generic_rate !==
                                                                  "" &&
                                                                  miscrate.generic_rate >
                                                                  0 ? (
                                                                  <>
                                                                    {this.formatAsCurrencys(
                                                                      miscrate.generic_rate,
                                                                    )}
                                                                  </>
                                                                ) : (
                                                                  "$0.00"
                                                                )}
                                                              </>
                                                            ) : null}
                                                          </td>
                                                        </tr>
                                                      ),
                                                    )}
                                                  </tbody>
                                                </table>
                                              </div>
                                            </>
                                          ) : null}
                                        </div>
                                      ) : null}
                                      {services[6] === "sms" ? (
                                        <div className="card-inner">
                                          <div className="sp-plan-head">
                                            <h6 className="title">
                                              {services[1]}{" "}
                                              <span className="badge badge-dim badge-primary badge-pill">
                                                New
                                              </span>
                                            </h6>
                                          </div>

                                          <div className="sp-plan-desc sp-plan-desc-mb">
                                            <ul className="row gx-1">
                                              <li className="col-sm-5">
                                                <p>
                                                  <span className="text-soft">
                                                    SMS In{" "}
                                                    <Tooltip
                                                      title="Price applied to SMS In Services."
                                                      placement="top"
                                                    >
                                                      <em
                                                        className="icon ni ni-info"
                                                        style={{
                                                          color: "#6576ff",
                                                        }}
                                                      ></em>
                                                    </Tooltip>
                                                  </span>{" "}
                                                  ${services[10]}
                                                </p>
                                              </li>
                                              <li className="col-sm-5">
                                                <p>
                                                  <span className="text-soft">
                                                    SMS Out{" "}
                                                    <Tooltip
                                                      title="Price applied to SMS Out Services."
                                                      placement="top"
                                                    >
                                                      <em
                                                        className="icon ni ni-info"
                                                        style={{
                                                          color: "#6576ff",
                                                        }}
                                                      ></em>
                                                    </Tooltip>
                                                  </span>{" "}
                                                  ${services[11]}
                                                </p>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      ) : null}
                                      {services[6] === "did" ||
                                        services[6] === "tfn" ||
                                        services[6] === "teams" ? (
                                        <>
                                          {services[30] &&
                                            services[30].length > 0 ? (
                                            <div className="card-inner">
                                              <div className="sp-plan-head">
                                                <h6 className="title">
                                                  Porting Rates
                                                </h6>
                                              </div>

                                              <div className="sp-plan-desc sp-plan-desc-mb">
                                                <ul className="row gx-1">
                                                  <li className="col-sm-5">
                                                    <p>
                                                      <span className="text-soft">
                                                        Portin Sell Rate
                                                      </span>{" "}
                                                      $
                                                      {services[30][0].portin_sell_rate.toFixed(
                                                        4,
                                                      )}
                                                    </p>
                                                  </li>
                                                  <li className="col-sm-5">
                                                    <p>
                                                      <span className="text-soft">
                                                        Portin Sell Rate
                                                      </span>{" "}
                                                      $
                                                      {services[30][0].portout_sell_rate.toFixed(
                                                        4,
                                                      )}
                                                    </p>
                                                  </li>
                                                </ul>
                                              </div>
                                            </div>
                                          ) : null}
                                        </>
                                      ) : null}
                                      <div className="card-inner">
                                        {services[23] !== "ratedeck" ? (
                                          <>
                                            <div className="sp-plan-head">
                                              <h6 className="title">
                                                Cancellation Fee
                                              </h6>
                                            </div>
                                            <div className="sp-plan-desc sp-plan-desc-mb">
                                              <ul className="row gx-1">
                                                <li className="col-sm-5">
                                                  <p>
                                                    <span className="text-soft">
                                                      Cancellation Fee
                                                    </span>{" "}
                                                    {services[29] &&
                                                      services[29] !== "" ? (
                                                      <>
                                                        $
                                                        {services[29].toFixed(
                                                          2,
                                                        )}
                                                      </>
                                                    ) : (
                                                      "$0.00"
                                                    )}
                                                  </p>
                                                </li>
                                              </ul>
                                            </div>
                                          </>
                                        ) : null}
                                        {services[23] === "ratedeck" ? (
                                          <>
                                            <div className="sp-plan-head">
                                              <h6 className="title">
                                                Rate Deck / Effective Date
                                              </h6>
                                            </div>
                                            <div className="sp-plan-desc sp-plan-desc-mb">
                                              <ul className="row gx-1">
                                                <li className="col-sm-5">
                                                  <p>
                                                    <span className="text-soft">
                                                      Rate Deck
                                                    </span>{" "}
                                                    {services[25] &&
                                                      services[25] !== "" ? (
                                                      <>
                                                        <a
                                                          onClick={() =>
                                                            this.downloadCsv(
                                                              services[25],
                                                            )
                                                          }
                                                          style={{
                                                            cursor: "pointer",
                                                          }}
                                                          className="btn btn-outline-primary"
                                                        >
                                                          <em className="icon ni ni-download"></em>{" "}
                                                          Download Rate Deck
                                                        </a>
                                                      </>
                                                    ) : null}
                                                  </p>
                                                </li>
                                                <li className="col-sm-5">
                                                  <p>
                                                    <span className="text-soft">
                                                      Effective Date
                                                    </span>{" "}
                                                    {services[24] &&
                                                      services[24] !== "" ? (
                                                      <>
                                                        {this.format_date(
                                                          services[24],
                                                        )}
                                                      </>
                                                    ) : null}
                                                  </p>
                                                </li>
                                              </ul>
                                            </div>
                                          </>
                                        ) : null}
                                        {services[31] &&
                                          services[31].length > 0 ? (
                                          <>
                                            <div
                                              className="sp-plan-head"
                                              style={{
                                                marginTop: "15px",
                                                borderTop: "1px solid #f6f6f6",
                                                paddingTop: "15px",
                                              }}
                                            >
                                              <h6 className="title">
                                                Miscellaneous Rates
                                              </h6>
                                            </div>
                                            <div className="sp-plan-desc sp-plan-desc-mb">
                                              <table className="table">
                                                <thead className="thead-light">
                                                  <tr>
                                                    <th scope="col">Title</th>
                                                    <th scope="col">
                                                      Rate Type
                                                    </th>
                                                    <th scope="col">Rate</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {services[31].map(
                                                    (miscrate, idx) => (
                                                      <tr key={`mis${idx}`}>
                                                        <td>
                                                          {miscrate.misc_title}
                                                        </td>
                                                        <td>
                                                          {miscrate.misc_type ===
                                                            "per_minute"
                                                            ? "Per Minute"
                                                            : ""}
                                                          {miscrate.misc_type ===
                                                            "per_hour"
                                                            ? "Per Hour"
                                                            : ""}
                                                          {miscrate.misc_type ===
                                                            "one_time"
                                                            ? "One Time"
                                                            : ""}
                                                        </td>
                                                        <td>
                                                          {miscrate.misc_rate !==
                                                            "" &&
                                                            miscrate.misc_rate >
                                                            0 ? (
                                                            <>
                                                              $
                                                              {miscrate.misc_rate.toFixed(
                                                                2,
                                                              )}
                                                            </>
                                                          ) : (
                                                            "$0.00"
                                                          )}
                                                        </td>
                                                      </tr>
                                                    ),
                                                  )}
                                                </tbody>
                                              </table>
                                            </div>
                                          </>
                                        ) : null}
                                      </div>

                                      <div className="card-inner">
                                        <div className="sp-plan-head-group">
                                          <div className="sp-plan-head">
                                            <h6 className="title">
                                              Short Description
                                            </h6>
                                            <span className="ff-italic text-soft">
                                              <div
                                                dangerouslySetInnerHTML={{
                                                  __html: services[3],
                                                }}
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* DETAILS MODAL */}
                  <div
                    className="modal fade zoom"
                    tabIndex="-1"
                    id="modalFormDetailBundle"
                  >
                    <div
                      className="modal-dialog modal-xl modal-dialog-top"
                      role="document"
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <div
                            className="modal-title"
                            style={{ textAlign: "center", fontSize: "20px" }}
                          >
                            <strong>
                              <em className="icon ni ni-list-round"></em> Bundle
                              Details
                            </strong>
                          </div>
                          <a
                            href="#"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                        </div>

                        <div className="modal-body">
                          <br />
                          {/* NRC DIVS START */}

                          {this.state.bundleDetails &&
                            this.state.bundleDetails.length > 0 ? (
                            <div className="card card-bordered">
                              <div className="card-inner-group">
                                <div className="card-inner">
                                  <div className="sp-plan-head">
                                    <h6 className="title">
                                      {this.state.bundleDetails[0].bundle_title}
                                    </h6>
                                  </div>
                                  <div
                                    className="sp-plan-desc sp-plan-desc-mb"
                                    style={{
                                      marginBottom: "15px",
                                      borderBottom:
                                        "1px solid rgb(246, 246, 246)",
                                      paddingBottom: "7px",
                                    }}
                                  >
                                    <ul className="row gx-1">
                                      <li className="col-sm-6">
                                        <p>
                                          <span className="text-soft">
                                            Per Month Rate (Charge Monthly){" "}
                                            <Tooltip
                                              title="Per Month Rate (Charge Monthly)"
                                              placement="top"
                                            >
                                              <em
                                                className="icon ni ni-info"
                                                style={{
                                                  color: "#6576ff",
                                                }}
                                              ></em>
                                            </Tooltip>
                                          </span>{" "}
                                          $
                                          {this.state.bundleDetails[0].per_month_rate.toFixed(
                                            4,
                                          )}
                                        </p>
                                      </li>
                                      <li className="col-sm-6">
                                        <p>
                                          <span className="text-soft">
                                            Per Month Rate (Charge Yearly)
                                            <Tooltip
                                              title="Per Month Rate (Charge Yearly)"
                                              placement="top"
                                            >
                                              <em
                                                className="icon ni ni-info"
                                                style={{
                                                  color: "#6576ff",
                                                }}
                                              ></em>
                                            </Tooltip>
                                          </span>{" "}
                                          $
                                          {this.state.bundleDetails[0].per_year_rate.toFixed(
                                            4,
                                          )}
                                        </p>
                                      </li>
                                    </ul>
                                  </div>
                                  <div
                                    className="sp-plan-desc sp-plan-desc-mb"
                                    style={{
                                      marginBottom: "15px",
                                      borderBottom:
                                        "1px solid rgb(246, 246, 246)",
                                      paddingBottom: "7px",
                                    }}
                                  >
                                    <ul className="row gx-1">
                                      <li className="col-sm-6">
                                        <p>
                                          <span className="text-soft">
                                            Date Added
                                            <Tooltip
                                              title="Date Added"
                                              placement="top"
                                            >
                                              <em
                                                className="icon ni ni-info"
                                                style={{
                                                  color: "#6576ff",
                                                }}
                                              ></em>
                                            </Tooltip>{" "}
                                          </span>{" "}
                                          {this.state.bundleDetails[0]
                                            .date_added !== ""
                                            ? this.format_date(
                                              this.state.bundleDetails[0]
                                                .date_added,
                                            )
                                            : null}
                                        </p>
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="sp-plan-desc sp-plan-desc-mb">
                                    <ul className="row gx-1">
                                      <li className="col-sm-6">
                                        <p>
                                          <span className="text-soft">
                                            Description
                                            <Tooltip
                                              title="Package Description"
                                              placement="top"
                                            >
                                              <em
                                                className="icon ni ni-info"
                                                style={{
                                                  color: "#6576ff",
                                                }}
                                              ></em>
                                            </Tooltip>{" "}
                                          </span>{" "}
                                          {
                                            this.state.bundleDetails[0]
                                              .product_desc
                                          }
                                        </p>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* DEFAULT MODAL START */}
                  <div
                    className="modal fade zoom"
                    tabIndex="-1"
                    id="modalFormDefault"
                  >
                    <div className="modal-dialog" role="document">
                      <div className="modal-content">
                        <a
                          href="#"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <em className="icon ni ni-cross"></em>
                        </a>
                        <div className="modal-body modal-body-lg text-center">
                          <div className="nk-modal">
                            <h4 className="nk-modal-title">Set Default</h4>
                            <div className="nk-modal-text">
                              <div className="caption-text">
                                {this.state.errorMessage !== "" ? (
                                  <div className="example-alert">
                                    <div className="alert alert-pro alert-danger">
                                      <div className="alert-text">
                                        <h4>Error</h4>
                                        <p>{this.state.errorMessage}</p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                                {this.state.successMessage !== "" ? (
                                  <div className="example-alert">
                                    <div className="alert alert-pro alert-success">
                                      <div className="alert-text">
                                        <h4>Success</h4>
                                        <p>{this.state.successMessage}</p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                                {this.state.waitMessage !== "" ? (
                                  <div className="example-alert">
                                    <div className="alert alert-pro alert-warning">
                                      <div className="alert-text">
                                        <h4>Waiting...</h4>
                                        <p>{this.state.waitMessage}</p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                            <div className="nk-modal-action"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* DEFAULT MODAL End */}

                  {/*  DETAILS MODAL*/}
                  <div
                    className="modal fade zoom"
                    tabIndex="-1"
                    id="modalFormDetailDash"
                  >
                    <div
                      className="modal-dialog modal-xl modal-dialog-top"
                      role="document"
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <div
                            className="modal-title"
                            style={{ textAlign: "center", fontSize: "20px" }}
                          >
                            <strong>
                              <em className="icon ni ni-list"></em>{" "}
                              {this.state.selectedServiceTitle ||
                                "Product Details"}
                            </strong>
                          </div>
                          <a
                            href="#"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                        </div>

                        <div className="modal-body">
                          {/* NRC DIVS START */}

                          {this.state.serviceData &&
                            this.state.serviceData.length > 0 ? (
                            <>
                              {this.state.serviceData.map((services, idx) => (
                                <React.Fragment key={`servi${idx}`}>
                                  {/* Simplified layout for rate deck products */}
                                  {services[39] && services[39] !== "" ? (
                                    <>
                                      {/* Description section directly under header */}
                                      <div
                                        style={{
                                          marginBottom: "20px",
                                          padding: "15px",
                                          backgroundColor: "#f8f9fa",
                                          borderRadius: "4px",
                                        }}
                                      >
                                        {services[3] &&
                                          services[3].trim() !== "" ? (
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: services[3],
                                            }}
                                          />
                                        ) : (
                                          <p className="text-muted">
                                            No description available.
                                          </p>
                                        )}
                                      </div>

                                      {/* Order button */}
                                      <div
                                        style={{
                                          marginBottom: "15px",
                                          textAlign: "end",
                                        }}
                                        className="text-primary"
                                      >
                                        {this.state.coming_soon === 1 ? (
                                          <span className="badge badge-outline-warning">
                                            <em className="icon ni ni-clock"></em>{" "}
                                            Coming Soon
                                          </span>
                                        ) : (
                                          <a
                                            href={
                                              this.state.form_accountno &&
                                                this.state.form_accountno !==
                                                "" &&
                                                this.state.form_link &&
                                                this.state.form_link !== ""
                                                ? `${APP_URL}${auth.getResellerRegToken()}/client/client_form_submit/${this.state.form_accountno
                                                }/${this.state.form_link}/${this.state.service_id
                                                }?order=add`
                                                : `${APP_URL}${auth.getResellerRegToken()}/client/EditSalesOrder/${this.getOrderNo()}/${this.state.service_id
                                                }?order=add`
                                            }
                                            className="btn btn-outline-primary"
                                            style={{
                                              cursor: "pointer",
                                            }}
                                          >
                                            <em className="icon ni ni-cart"></em>{" "}
                                            <span>
                                              {this.state.form_accountno &&
                                                this.state.form_accountno !==
                                                "" &&
                                                this.state.form_link &&
                                                this.state.form_link !== ""
                                                ? "Form Order"
                                                : "Order Now"}
                                            </span>
                                          </a>
                                        )}
                                      </div>

                                      {/* Keep Rate Deck download and other non-pricing sections */}
                                      <div className="card card-bordered">
                                        {this.state.unsigned_agreement_title &&
                                          this.state.unsigned_agreement_title !==
                                          "" ? (
                                          <div className="example-alert">
                                            <div className="alert alert-warning alert-icon">
                                              <em className="icon ni ni-alert-circle"></em>{" "}
                                              Your agreement (
                                              {
                                                this.state
                                                  .unsigned_agreement_title
                                              }
                                              ) for this service is pending
                                              sign. Please sign this agreement
                                              to fully access and use this
                                              service.{" "}
                                              <a
                                                href={`${APP_URL}${auth.getResellerRegToken()}/client/agreements/unsignedAgreement/${services[43]
                                                  }`}
                                                className="text-primary"
                                                style={{
                                                  cursor: "pointer",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                Click Here
                                              </a>{" "}
                                              to sign this agreement.{" "}
                                            </div>
                                          </div>
                                        ) : null}
                                        <div className="card-inner-group">
                                          {/* <div className="card-inner">
                                            <div className="sp-plan-head">
                                              <h6 className="title">
                                                Rate Deck / Effective Date
                                              </h6>
                                            </div>
                                            <div className="sp-plan-desc sp-plan-desc-mb">
                                              <ul className="row gx-1">
                                                <li className="col-sm-5">
                                                  <p>
                                                    <span className="text-soft">
                                                      Rate Deck
                                                    </span>{" "}
                                                    {services[25] &&
                                                    services[25] !== "" ? (
                                                      <>
                                                        <a
                                                          onClick={() =>
                                                            this.downloadCsv(
                                                              services[25]
                                                            )
                                                          }
                                                          style={{
                                                            cursor: "pointer",
                                                          }}
                                                          className="btn btn-outline-primary"
                                                        >
                                                          <em className="icon ni ni-download"></em>{" "}
                                                          Download Rate Deck
                                                        </a>
                                                      </>
                                                    ) : null}
                                                  </p>
                                                </li>
                                                <li className="col-sm-5">
                                                  <p>
                                                    <span className="text-soft">
                                                      Effective Date
                                                    </span>{" "}
                                                    {services[24] &&
                                                    services[24] !== "" ? (
                                                      <>
                                                        {this.format_date(
                                                          services[24]
                                                        )}
                                                      </>
                                                    ) : null}
                                                  </p>
                                                </li>
                                              </ul>
                                            </div>
                                          </div> */}

                                          {services[35] &&
                                            services[35] === "link" &&
                                            services[36] !== "" ? (
                                            <>
                                              {services[36] !== "" ? (
                                                <div className="card-inner">
                                                  <div className="sp-plan-head">
                                                    <h6 className="title">
                                                      Marketing Link
                                                    </h6>
                                                  </div>
                                                  <div className="sp-plan-desc sp-plan-desc-mb">
                                                    <ul className="row gx-1">
                                                      <li className="col-sm-5">
                                                        <p>
                                                          <span className="text-soft">
                                                            Marketing Link
                                                          </span>{" "}
                                                          <a
                                                            href={services[36]}
                                                            target="_blank"
                                                          >
                                                            <em className="icon ni ni-link-h"></em>{" "}
                                                            Click to open link
                                                          </a>
                                                        </p>
                                                      </li>
                                                    </ul>
                                                  </div>
                                                </div>
                                              ) : null}
                                            </>
                                          ) : null}
                                          {services[35] &&
                                            services[35] === "pdf" &&
                                            services[36] !== "" ? (
                                            <>
                                              {services[36] !== "" ? (
                                                <div className="card-inner">
                                                  <div className="sp-plan-head">
                                                    <h6 className="title">
                                                      Marketing{" "}
                                                      {(() => {
                                                        const fileUrl =
                                                          services[36];
                                                        const fileExtension =
                                                          fileUrl
                                                            .split(".")
                                                            .pop()
                                                            .toLowerCase();
                                                        return [
                                                          "jpg",
                                                          "jpeg",
                                                          "png",
                                                        ].includes(
                                                          fileExtension,
                                                        )
                                                          ? "Image"
                                                          : "Link";
                                                      })()}
                                                    </h6>
                                                  </div>
                                                  <div className="sp-plan-desc sp-plan-desc-mb">
                                                    <ul className="row gx-1">
                                                      <li className="col-sm-5">
                                                        <p>
                                                          <span className="text-soft">
                                                            Marketing{" "}
                                                            {(() => {
                                                              const fileUrl =
                                                                services[36];
                                                              const fileExtension =
                                                                fileUrl
                                                                  .split(".")
                                                                  .pop()
                                                                  .toLowerCase();
                                                              return [
                                                                "jpg",
                                                                "jpeg",
                                                                "png",
                                                              ].includes(
                                                                fileExtension,
                                                              )
                                                                ? "Image"
                                                                : "Link";
                                                            })()}
                                                          </span>{" "}
                                                          {(() => {
                                                            const fileUrl =
                                                              services[36];
                                                            const fileExtension =
                                                              fileUrl
                                                                .split(".")
                                                                .pop()
                                                                .toLowerCase();
                                                            const isImage = [
                                                              "jpg",
                                                              "jpeg",
                                                              "png",
                                                            ].includes(
                                                              fileExtension,
                                                            );

                                                            if (isImage) {
                                                              return (
                                                                <img
                                                                  src={fileUrl}
                                                                  alt="Marketing"
                                                                  style={{
                                                                    maxWidth:
                                                                      "300px",
                                                                    maxHeight:
                                                                      "200px",
                                                                    objectFit:
                                                                      "contain",
                                                                  }}
                                                                />
                                                              );
                                                            } else {
                                                              return (
                                                                <a
                                                                  href={
                                                                    services[36]
                                                                  }
                                                                  target="_blank"
                                                                >
                                                                  <em className="icon ni ni-file-pdf"></em>{" "}
                                                                  View PDF
                                                                </a>
                                                              );
                                                            }
                                                          })()}
                                                        </p>
                                                      </li>
                                                    </ul>
                                                  </div>
                                                </div>
                                              ) : null}
                                            </>
                                          ) : null}

                                          {/* Document/Rate Deck download */}
                                          {services[39] &&
                                            services[39] !== "" ? (
                                            <div className="card-inner">
                                              <div className="sp-plan-head-group">
                                                <div className="sp-plan-head">
                                                  <h6 className="title">
                                                    Document / Rate Deck{" "}
                                                  </h6>
                                                </div>
                                              </div>
                                              <div className="sp-plan-desc sp-plan-desc-mb">
                                                <ul className="row gx-1">
                                                  <li className="col-sm-5">
                                                    <p>
                                                      <br />
                                                      <a
                                                        onClick={() =>
                                                          this.downloadDeck(
                                                            services[39],
                                                          )
                                                        }
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        className="text-primary"
                                                      >
                                                        <em className="icon ni ni-download"></em>{" "}
                                                        {services[38]}{" "}
                                                        {this.state
                                                          .downloadLoader ===
                                                          true ? (
                                                          <div
                                                            className="spinner-border spinner-border-sm text-primary"
                                                            role="status"
                                                          >
                                                            <span className="sr-only">
                                                              Loading...
                                                            </span>
                                                          </div>
                                                        ) : null}
                                                      </a>
                                                    </p>
                                                  </li>
                                                </ul>
                                              </div>
                                            </div>
                                          ) : null}

                                          {/* 3rd Party Integration */}
                                          {services[40] &&
                                            services[40] !== "" ? (
                                            <div className="card-inner">
                                              <div className="sp-plan-head-group">
                                                <div className="sp-plan-head">
                                                  <h6 className="title">
                                                    3rd Party Integration{" "}
                                                  </h6>
                                                  <span className="text-body">
                                                    <div
                                                      dangerouslySetInnerHTML={{
                                                        __html: services[41],
                                                      }}
                                                    />
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          ) : null}
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      {/* Standard layout for non-rate deck products */}
                                      <div
                                        style={{
                                          marginBottom: "15px",
                                          textAlign: "end",
                                        }}
                                        className="text-primary"
                                      >
                                        {this.state.coming_soon === 1 ? (
                                          <span className="badge badge-outline-warning">
                                            <em className="icon ni ni-clock"></em>{" "}
                                            Coming Soon
                                          </span>
                                        ) : (
                                          <a
                                            href={
                                              this.state.form_accountno &&
                                                this.state.form_accountno !==
                                                "" &&
                                                this.state.form_link &&
                                                this.state.form_link !== ""
                                                ? `${APP_URL}${auth.getResellerRegToken()}/client/client_form_submit/${this.state.form_accountno
                                                }/${this.state.form_link}/${this.state.service_id
                                                }?order=add`
                                                : `${APP_URL}${auth.getResellerRegToken()}/client/EditSalesOrder/${this.getOrderNo()}/${this.state.service_id
                                                }?order=add`
                                            }
                                            className="btn btn-outline-primary"
                                            style={{
                                              cursor: "pointer",
                                            }}
                                          >
                                            <em className="icon ni ni-cart"></em>{" "}
                                            <span>
                                              {this.state.form_accountno &&
                                                this.state.form_accountno !==
                                                "" &&
                                                this.state.form_link &&
                                                this.state.form_link !== ""
                                                ? "Form Order"
                                                : "Order Now"}
                                            </span>
                                          </a>
                                        )}
                                      </div>
                                      <div>
                                        <div className="card card-bordered">
                                          {this.state
                                            .unsigned_agreement_title &&
                                            this.state
                                              .unsigned_agreement_title !== "" ? (
                                            <div className="example-alert">
                                              <div className="alert alert-warning alert-icon">
                                                <em className="icon ni ni-alert-circle"></em>{" "}
                                                Your agreement (
                                                {
                                                  this.state
                                                    .unsigned_agreement_title
                                                }
                                                ) for this service is pending
                                                sign. Please sign this agreement
                                                to fully access and use this
                                                service.{" "}
                                                <a
                                                  href={`${APP_URL}${auth.getResellerRegToken()}/client/agreements/unsignedAgreement/${services[43]
                                                    }`}
                                                  className="text-primary"
                                                  style={{
                                                    cursor: "pointer",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  Click Here
                                                </a>{" "}
                                                to sign this agreement.{" "}
                                              </div>
                                            </div>
                                          ) : null}
                                          <div className="card-inner-group">
                                            {!(
                                              services[39] &&
                                              services[39] !== ""
                                            ) &&
                                              (services[6] === "did" ||
                                                services[6] === "tfn" ||
                                                services[6] === "teams") ? (
                                              <div className="card-inner">
                                                <div className="sp-plan-head">
                                                  <div className="col-md-8">
                                                    <h6 className="title">
                                                      {services[1]}
                                                    </h6>
                                                  </div>
                                                  <div className="4">
                                                    <div className="price-plan-amount">
                                                      <div className="amount"></div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="sp-plan-desc sp-plan-desc-mb">
                                                  <ul className="row gx-1">
                                                    <li className="col-sm-4">
                                                      <p>
                                                        <span className="text-soft">
                                                          NRC
                                                          <Tooltip
                                                            title="Non-Recurring Charge – A one-time fee that is deducted on service setup."
                                                            placement="top"
                                                          >
                                                            <em
                                                              className="icon ni ni-info"
                                                              style={{
                                                                color:
                                                                  "#6576ff",
                                                              }}
                                                            ></em>
                                                          </Tooltip>
                                                        </span>{" "}
                                                        ${services[4]}
                                                      </p>
                                                    </li>
                                                    <li className="col-sm-4">
                                                      <p>
                                                        <span className="text-soft">
                                                          MRC{" "}
                                                          <Tooltip
                                                            title="Monthly Recurring Charge - what you pay each month for the service."
                                                            placement="top"
                                                          >
                                                            <em
                                                              className="icon ni ni-info"
                                                              style={{
                                                                color:
                                                                  "#6576ff",
                                                              }}
                                                            ></em>
                                                          </Tooltip>
                                                        </span>{" "}
                                                        ${services[5]}
                                                      </p>
                                                    </li>
                                                    <li className="col-sm-4">
                                                      <p>
                                                        <span className="text-soft">
                                                          Rate Per Minute{" "}
                                                          <Tooltip
                                                            title="Rate assigned per minute."
                                                            placement="top"
                                                          >
                                                            <em
                                                              className="icon ni ni-info"
                                                              style={{
                                                                color:
                                                                  "#6576ff",
                                                              }}
                                                            ></em>
                                                          </Tooltip>
                                                        </span>{" "}
                                                        ${services[7]}
                                                      </p>
                                                    </li>
                                                  </ul>
                                                </div>
                                              </div>
                                            ) : null}
                                            {!(
                                              services[39] &&
                                              services[39] !== ""
                                            ) &&
                                              (services[6] === "term" ||
                                                services[6] === "ivr" ||
                                                services[6] === "live_agent" ||
                                                services[6] === "tfn_term" ||
                                                services[6] === "az_term" ||
                                                services[6] === "generic") ? (
                                              <div className="card-inner">
                                                <div className="sp-plan-head">
                                                  <div className="row g-gs">
                                                    <div className="col-md-8">
                                                      <h6 className="title">
                                                        {services[1]}
                                                      </h6>
                                                    </div>
                                                    <div className="col-md-4 text-right">
                                                      <div className="price-plan-amount">
                                                        <div className="amount">
                                                          <span className="bill fs-12px">
                                                            Price:{" "}
                                                          </span>

                                                          {this.formatAsCurrencys(
                                                            services[7],
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="sp-plan-desc sp-plan-desc-mb">
                                                  {services[42]}
                                                </div>
                                                {services[6] === "generic" ? (
                                                  <>
                                                    <div
                                                      className="sp-plan-head"
                                                      style={{
                                                        marginTop: "15px",
                                                        borderTop:
                                                          "1px solid #f6f6f6",
                                                        paddingTop: "15px",
                                                      }}
                                                    >
                                                      <h6 className="title">
                                                        Other Service Rates
                                                      </h6>
                                                    </div>
                                                    <div className="sp-plan-desc sp-plan-desc-mb">
                                                      <table className="table">
                                                        <thead className="thead-light">
                                                          <tr>
                                                            <th scope="col">
                                                              Title
                                                            </th>
                                                            <th scope="col">
                                                              Charge Type
                                                            </th>
                                                            <th scope="col">
                                                              Cycle
                                                            </th>
                                                            <th scope="col">
                                                              Price
                                                            </th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {services[34].map(
                                                            (miscrate, idx) => (
                                                              <tr
                                                                key={`mis${idx}`}
                                                              >
                                                                <td>
                                                                  {
                                                                    miscrate.generic_title
                                                                  }
                                                                </td>
                                                                <td>
                                                                  {miscrate.included_in_price !==
                                                                    0 ? (
                                                                    <>
                                                                      {miscrate.pay_type ===
                                                                        "recurring"
                                                                        ? "Recurring"
                                                                        : ""}

                                                                      {miscrate.pay_type ===
                                                                        "one_time"
                                                                        ? "One Time"
                                                                        : ""}
                                                                    </>
                                                                  ) : null}
                                                                </td>
                                                                <td>
                                                                  {miscrate.included_in_price !==
                                                                    0 ? (
                                                                    <>
                                                                      {miscrate.pay_type ===
                                                                        "recurring" ? (
                                                                        <>
                                                                          {miscrate.generic_type ===
                                                                            "per_minute"
                                                                            ? "Per Minute"
                                                                            : ""}
                                                                          {miscrate.generic_type ===
                                                                            "per_hour"
                                                                            ? "Per Hour"
                                                                            : ""}
                                                                          {miscrate.generic_type ===
                                                                            "per_second"
                                                                            ? "Per Second"
                                                                            : ""}
                                                                          {miscrate.generic_type ===
                                                                            "per_day"
                                                                            ? "Per Day"
                                                                            : ""}
                                                                          {miscrate.generic_type ===
                                                                            "per_month"
                                                                            ? "Per Month"
                                                                            : ""}
                                                                          {miscrate.generic_type ===
                                                                            "per_year"
                                                                            ? "Per Year"
                                                                            : ""}
                                                                        </>
                                                                      ) : null}
                                                                    </>
                                                                  ) : null}
                                                                </td>
                                                                <td>
                                                                  {miscrate.included_in_price !==
                                                                    0 ? (
                                                                    <>
                                                                      {miscrate.generic_rate !==
                                                                        "" &&
                                                                        miscrate.generic_rate >
                                                                        0 ? (
                                                                        <>
                                                                          {this.formatAsCurrencys(
                                                                            miscrate.generic_rate,
                                                                          )}
                                                                        </>
                                                                      ) : (
                                                                        "$0.00"
                                                                      )}
                                                                    </>
                                                                  ) : null}
                                                                </td>
                                                              </tr>
                                                            ),
                                                          )}
                                                        </tbody>
                                                      </table>
                                                    </div>
                                                  </>
                                                ) : null}
                                              </div>
                                            ) : null}
                                            {!(
                                              services[39] &&
                                              services[39] !== ""
                                            ) && services[6] === "sms" ? (
                                              <div className="card-inner">
                                                <div className="sp-plan-head">
                                                  <h6 className="title">
                                                    {services[1]}{" "}
                                                    <span className="badge badge-dim badge-primary badge-pill">
                                                      New
                                                    </span>
                                                  </h6>
                                                </div>

                                                <div className="sp-plan-desc sp-plan-desc-mb">
                                                  <ul className="row gx-1">
                                                    <li className="col-sm-5">
                                                      <p>
                                                        <span className="text-soft">
                                                          SMS In{" "}
                                                          <Tooltip
                                                            title="Price applied to SMS In Services."
                                                            placement="top"
                                                          >
                                                            <em
                                                              className="icon ni ni-info"
                                                              style={{
                                                                color:
                                                                  "#6576ff",
                                                              }}
                                                            ></em>
                                                          </Tooltip>
                                                        </span>{" "}
                                                        ${services[10]}
                                                      </p>
                                                    </li>
                                                    <li className="col-sm-5">
                                                      <p>
                                                        <span className="text-soft">
                                                          SMS Out{" "}
                                                          <Tooltip
                                                            title="Price applied to SMS Out Services."
                                                            placement="top"
                                                          >
                                                            <em
                                                              className="icon ni ni-info"
                                                              style={{
                                                                color:
                                                                  "#6576ff",
                                                              }}
                                                            ></em>
                                                          </Tooltip>
                                                        </span>{" "}
                                                        ${services[11]}
                                                      </p>
                                                    </li>
                                                  </ul>
                                                </div>
                                              </div>
                                            ) : null}
                                            {!(
                                              services[39] &&
                                              services[39] !== ""
                                            ) &&
                                              (services[6] === "did" ||
                                                services[6] === "tfn" ||
                                                services[6] === "teams") ? (
                                              <>
                                                {services[30] &&
                                                  services[30].length > 0 ? (
                                                  <div className="card-inner">
                                                    <div className="sp-plan-head">
                                                      <h6 className="title">
                                                        Porting Rates
                                                      </h6>
                                                    </div>

                                                    <div className="sp-plan-desc sp-plan-desc-mb">
                                                      <ul className="row gx-1">
                                                        <li className="col-sm-5">
                                                          <p>
                                                            <span className="text-soft">
                                                              Portin Sell Rate
                                                            </span>{" "}
                                                            $
                                                            {services[30][0].portin_sell_rate.toFixed(
                                                              4,
                                                            )}
                                                          </p>
                                                        </li>
                                                        <li className="col-sm-5">
                                                          <p>
                                                            <span className="text-soft">
                                                              Portin Sell Rate
                                                            </span>{" "}
                                                            $
                                                            {services[30][0].portout_sell_rate.toFixed(
                                                              4,
                                                            )}
                                                          </p>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                ) : null}
                                              </>
                                            ) : null}

                                            {!(
                                              services[39] &&
                                              services[39] !== ""
                                            ) ? (
                                              <>
                                                {services[29] &&
                                                  services[29] !== "" &&
                                                  services[29] > 0 ? (
                                                  <div className="card-inner">
                                                    <div className="sp-plan-head">
                                                      <h6 className="title">
                                                        Cancellation Fee
                                                      </h6>
                                                    </div>
                                                    <div className="sp-plan-desc sp-plan-desc-mb">
                                                      <ul className="row gx-1">
                                                        <li className="col-sm-5">
                                                          <p>
                                                            {services[29] &&
                                                              services[29] !==
                                                              "" ? (
                                                              <>
                                                                {this.formatAsCurrencys(
                                                                  services[29],
                                                                )}
                                                              </>
                                                            ) : (
                                                              "$0.00"
                                                            )}
                                                          </p>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                ) : null}
                                              </>
                                            ) : null}

                                            {services[39] &&
                                              services[39] !== "" ? (
                                              <div className="card-inner">
                                                <div className="sp-plan-head">
                                                  <h6 className="title">
                                                    Rate Deck / Effective Date
                                                  </h6>
                                                </div>
                                                <div className="sp-plan-desc sp-plan-desc-mb">
                                                  <ul className="row gx-1">
                                                    <li className="col-sm-5">
                                                      <p>
                                                        <span className="text-soft">
                                                          Rate Deck
                                                        </span>{" "}
                                                        {services[25] &&
                                                          services[25] !== "" ? (
                                                          <>
                                                            <a
                                                              onClick={() =>
                                                                this.downloadCsv(
                                                                  services[25],
                                                                )
                                                              }
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                              }}
                                                              className="btn btn-outline-primary"
                                                            >
                                                              <em className="icon ni ni-download"></em>{" "}
                                                              Download Rate Deck
                                                            </a>
                                                          </>
                                                        ) : null}
                                                      </p>
                                                    </li>
                                                    <li className="col-sm-5">
                                                      <p>
                                                        <span className="text-soft">
                                                          Effective Date
                                                        </span>{" "}
                                                        {services[24] &&
                                                          services[24] !== "" ? (
                                                          <>
                                                            {this.format_date(
                                                              services[24],
                                                            )}
                                                          </>
                                                        ) : null}
                                                      </p>
                                                    </li>
                                                  </ul>
                                                </div>
                                              </div>
                                            ) : null}

                                            {services[31] &&
                                              services[31].length > 0 ? (
                                              <div className="card-inner">
                                                <div
                                                  className="sp-plan-head"
                                                  style={{
                                                    marginTop: "15px",
                                                    borderTop:
                                                      "1px solid #f6f6f6",
                                                    paddingTop: "15px",
                                                  }}
                                                >
                                                  <h6 className="title">
                                                    Miscellaneous Rates
                                                  </h6>
                                                </div>
                                                <div className="sp-plan-desc sp-plan-desc-mb">
                                                  <table className="table">
                                                    <thead className="thead-light">
                                                      <tr>
                                                        <th scope="col">
                                                          Title
                                                        </th>
                                                        <th scope="col">
                                                          Rate Type
                                                        </th>
                                                        <th scope="col">
                                                          Rate
                                                        </th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {services[31].map(
                                                        (miscrate, idx) => (
                                                          <>
                                                            {miscrate.misc_title &&
                                                              miscrate.misc_title !==
                                                              "" ? (
                                                              <tr
                                                                key={`mis${idx}`}
                                                              >
                                                                <td>
                                                                  {
                                                                    miscrate.misc_title
                                                                  }
                                                                </td>
                                                                <td>
                                                                  {miscrate.misc_type ===
                                                                    "per_minute"
                                                                    ? "Per Minute"
                                                                    : ""}
                                                                  {miscrate.misc_type ===
                                                                    "per_hour"
                                                                    ? "Per Hour"
                                                                    : ""}
                                                                  {miscrate.misc_type ===
                                                                    "one_time"
                                                                    ? "One Time"
                                                                    : ""}
                                                                </td>
                                                                <td>
                                                                  {miscrate.misc_rate !==
                                                                    "" &&
                                                                    miscrate.misc_rate >
                                                                    0 ? (
                                                                    <>
                                                                      {this.formatAsCurrencys(
                                                                        miscrate.misc_rate,
                                                                      )}
                                                                    </>
                                                                  ) : (
                                                                    "$0.00"
                                                                  )}
                                                                </td>
                                                              </tr>
                                                            ) : null}
                                                          </>
                                                        ),
                                                      )}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            ) : null}

                                            {services[35] &&
                                              services[35] === "link" &&
                                              services[36] !== "" ? (
                                              <>
                                                {services[36] !== "" ? (
                                                  <div className="card-inner">
                                                    <div className="sp-plan-head">
                                                      <h6 className="title">
                                                        Marketing Link
                                                      </h6>
                                                    </div>
                                                    <div className="sp-plan-desc sp-plan-desc-mb">
                                                      <ul className="row gx-1">
                                                        <li className="col-sm-5">
                                                          <p>
                                                            <span className="text-soft">
                                                              Marketing Link
                                                            </span>{" "}
                                                            <a
                                                              href={
                                                                services[36]
                                                              }
                                                              target="_blank"
                                                            >
                                                              <em className="icon ni ni-link-h"></em>{" "}
                                                              Click to open link
                                                            </a>
                                                          </p>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                ) : null}
                                              </>
                                            ) : null}
                                            {services[35] &&
                                              services[35] === "pdf" &&
                                              services[36] !== "" ? (
                                              <>
                                                {services[36] !== "" ? (
                                                  <div className="card-inner">
                                                    <div className="sp-plan-head">
                                                      <h6 className="title">
                                                        Marketing{" "}
                                                        {(() => {
                                                          const fileUrl =
                                                            services[36];
                                                          const fileExtension =
                                                            fileUrl
                                                              .split(".")
                                                              .pop()
                                                              .toLowerCase();
                                                          return [
                                                            "jpg",
                                                            "jpeg",
                                                            "png",
                                                          ].includes(
                                                            fileExtension,
                                                          )
                                                            ? "Image"
                                                            : "Link";
                                                        })()}
                                                      </h6>
                                                    </div>
                                                    <div className="sp-plan-desc sp-plan-desc-mb">
                                                      <ul className="row gx-1">
                                                        <li className="col-sm-5">
                                                          <p>
                                                            <span className="text-soft">
                                                              Marketing{" "}
                                                              {(() => {
                                                                const fileUrl =
                                                                  services[36];
                                                                const fileExtension =
                                                                  fileUrl
                                                                    .split(".")
                                                                    .pop()
                                                                    .toLowerCase();
                                                                return [
                                                                  "jpg",
                                                                  "jpeg",
                                                                  "png",
                                                                ].includes(
                                                                  fileExtension,
                                                                )
                                                                  ? "Image"
                                                                  : "Link";
                                                              })()}
                                                            </span>{" "}
                                                            {(() => {
                                                              const fileUrl =
                                                                services[36];
                                                              const fileExtension =
                                                                fileUrl
                                                                  .split(".")
                                                                  .pop()
                                                                  .toLowerCase();
                                                              const isImage = [
                                                                "jpg",
                                                                "jpeg",
                                                                "png",
                                                              ].includes(
                                                                fileExtension,
                                                              );

                                                              if (isImage) {
                                                                return (
                                                                  <img
                                                                    src={
                                                                      fileUrl
                                                                    }
                                                                    alt="Marketing"
                                                                    style={{
                                                                      maxWidth:
                                                                        "300px",
                                                                      maxHeight:
                                                                        "200px",
                                                                      objectFit:
                                                                        "contain",
                                                                    }}
                                                                  />
                                                                );
                                                              } else {
                                                                return (
                                                                  <a
                                                                    href={
                                                                      services[36]
                                                                    }
                                                                    target="_blank"
                                                                  >
                                                                    <em className="icon ni ni-file-pdf"></em>{" "}
                                                                    View PDF
                                                                  </a>
                                                                );
                                                              }
                                                            })()}
                                                          </p>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                ) : null}
                                              </>
                                            ) : null}

                                            {services[39] &&
                                              services[39] !== "" ? (
                                              <div className="card-inner">
                                                <div className="sp-plan-head-group">
                                                  <div className="sp-plan-head">
                                                    <h6 className="title">
                                                      Document / Rate Deck{" "}
                                                    </h6>
                                                  </div>
                                                </div>
                                                <div className="sp-plan-desc sp-plan-desc-mb">
                                                  <ul className="row gx-1">
                                                    <li className="col-sm-5">
                                                      <p>
                                                        <br />
                                                        <a
                                                          onClick={() =>
                                                            this.downloadDeck(
                                                              services[39],
                                                            )
                                                          }
                                                          style={{
                                                            cursor: "pointer",
                                                          }}
                                                          className="text-primary"
                                                        >
                                                          <em className="icon ni ni-download"></em>{" "}
                                                          {services[38]}{" "}
                                                          {this.state
                                                            .downloadLoader ===
                                                            true ? (
                                                            <div
                                                              className="spinner-border spinner-border-sm text-primary"
                                                              role="status"
                                                            >
                                                              <span className="sr-only">
                                                                Loading...
                                                              </span>
                                                            </div>
                                                          ) : null}
                                                        </a>
                                                      </p>
                                                    </li>
                                                  </ul>
                                                </div>
                                              </div>
                                            ) : null}

                                            {services[40] &&
                                              services[40] !== "" ? (
                                              <div className="card-inner">
                                                <div className="sp-plan-head-group">
                                                  <div className="sp-plan-head">
                                                    <h6 className="title">
                                                      3rd Party Integration{" "}
                                                    </h6>
                                                    <span className="text-body">
                                                      <div
                                                        dangerouslySetInnerHTML={{
                                                          __html: services[41],
                                                        }}
                                                      />
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : null}
                                            <div className="card-inner p_description">
                                              <div className="sp-plan-head-group">
                                                <div className="sp-plan-head">
                                                  <h6 className="title">
                                                    Description
                                                  </h6>
                                                  <span className="text-body">
                                                    <div
                                                      dangerouslySetInnerHTML={{
                                                        __html: services[3],
                                                      }}
                                                    />
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </React.Fragment>
                              ))}
                            </>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* DETAILS MODAL */}

                  {/* Link Modal MODAL START */}
                  <div
                    className="modal fade zoom"
                    tabIndex="-1"
                    id="modalMarketingLink"
                  >
                    <div
                      className="modal-dialog modal-xl modal-dialog-top"
                      role="document"
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <div
                            className="modal-title"
                            style={{ textAlign: "center", fontSize: "20px" }}
                          >
                            <strong>
                              <em className="icon ni ni-list-round"></em>{" "}
                              Marketing Link
                            </strong>
                          </div>
                          <a
                            className="close"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              this.modalHideMarketingLink();
                            }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                        </div>

                        <div className="modal-body">
                          <br />
                          <iframe
                            src={this.state.currentlink}
                            title="Marketing Link"
                            width="100%"
                            height={newHeight * 0.61}
                            style={{ border: "none" }}
                          ></iframe>
                          {/* {console.log("my screen => ", window.screen.height)} */}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* LINK MODAL End */}

                  {/* Link Modal MODAL START */}
                  <div
                    className="modal fade zoom"
                    tabIndex="-1"
                    id="modalMarketingPDFLink"
                  >
                    <div
                      className="modal-dialog modal-xl modal-dialog-top"
                      role="document"
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <div
                            className="modal-title"
                            style={{ textAlign: "center", fontSize: "20px" }}
                          >
                            <strong>
                              <em className="icon ni ni-list-round"></em>{" "}
                              Marketing PDF
                            </strong>
                          </div>
                          <a
                            className="close"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              this.modalHideMarketingPDF();
                            }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                        </div>

                        <div className="modal-body">
                          <br />
                          <embed
                            src={this.state.currentPdfLink}
                            type="application/pdf"
                            width="100%"
                            height={newHeight * 0.61}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* LINK MODAL End */}

                  {/* SSO Modal MODAL START */}
                  <div
                    className="modal fade zoom"
                    tabIndex="-1"
                    id="modalSsoRegister"
                  >
                    <div
                      className="modal-dialog modal-xl modal-dialog-top"
                      role="document"
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <div
                            className="modal-title"
                            style={{ textAlign: "center", fontSize: "20px" }}
                          >
                            <strong>
                              <em className="icon ni ni-list-round"></em>{" "}
                              VoyceAdmins
                            </strong>
                          </div>
                          <a
                            className="close"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              this.modalHideSsoRegister();
                            }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                        </div>

                        <div className="modal-body">
                          <br />
                          {this.state.successMessageSso !== "" ? (
                            <div className="example-alert mb-4">
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessageSso}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.errorMessageSso !== "" ? (
                            <div className="example-alert mb-3">
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessageSso}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          <iframe
                            src={this.state.sso_link}
                            title="Voyceadmins"
                            width="100%"
                            height={newHeight * 0.61}
                            style={{ border: "none" }}
                          ></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* SSSO MODAL End */}

                  {/* SSO Modal MODAL START */}
                  <div
                    className="modal fade zoom"
                    tabIndex="-1"
                    id="modalSsoLogin"
                  >
                    <div
                      className="modal-dialog modal-lg modal-dialog-top"
                      role="document"
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <div
                            className="modal-title"
                            style={{ textAlign: "center", fontSize: "20px" }}
                          >
                            <strong>
                              <em className="icon ni ni-list-round"></em>{" "}
                              VoyceAdmins
                            </strong>
                          </div>
                          <a
                            className="close"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              this.modalHideSsoLogin();
                            }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                        </div>

                        <div className="modal-body">
                          {this.state.errorMessageSso !== "" ? (
                            <div className="example-alert mb-3">
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessageSso}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.successMessageSso !== "" ? (
                            <div className="example-alert mb-3">
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessageSso}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          <div className="row g-4">
                            <div className="col-lg-12">
                              <div
                                className="card"
                                style={{ alignItems: "center" }}
                              >
                                <div
                                  style={{ width: "150px", height: "120px" }}
                                >
                                  <img
                                    src="../../../assets/integrations/voice-adm.png"
                                    className="card-img-top img_settings"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div className="form-group">
                                <TextField
                                  label="Email"
                                  error={this.state.errorLoginEmail}
                                  id="login_email"
                                  name="login_email"
                                  value={this.state.login_email}
                                  placeholder="Email"
                                  change={this.handleChange}
                                  type="text"
                                />
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div className="form-group">
                                <TextField
                                  label="Password"
                                  error={this.state.errorLoginPassword}
                                  id="login_password"
                                  name="login_password"
                                  value={this.state.login_password}
                                  placeholder="Password"
                                  change={this.handleChange}
                                  type="Password"
                                />
                              </div>
                              <a
                                className="link link-primary link-sm"
                                tabIndex="-1"
                                href={this.state.forgotLink}
                                style={{
                                  float: "right",
                                }}
                              >
                                Forgot Password?
                              </a>
                            </div>
                            <div className="col-lg-12">
                              <button
                                type="button"
                                className="btn btn-lg btn-block"
                                onClick={() => {
                                  this.formLogin();
                                }}
                                style={{
                                  backgroundColor: THEME_COLOR,
                                  color: THEME_TEXT_COLOR,
                                }}
                                disabled={this.state.disabled}
                              >
                                Login
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* SSSO MODAL End */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
    quotationSettings: state.quotationSettings,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Services);
